import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {HomeComponent} from "./sites/home/home.component";

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    data: { breadcrumb: 'Home'}
  },
  {
    path: 'magazin',
    data: { breadcrumb: 'Magazin'},
    children: [
      {
        path: '',
        loadComponent: () => import('./sites/blog/blog.component')
          .then(m => m.BlogComponent)
      },
      {
        path: 'kategorie',
        pathMatch: 'full',
        redirectTo: '/magazin'
      },
      {
        path: 'kategorie/:kategorie',
        loadComponent: () => import('./sites/blog/kategorien/kategorie.component')
          .then(m => m.KategorieComponent),
        data: { breadcrumb: 'Kategorie'}
      },
      {
        path: ':slug',
        loadComponent: () => import('./sites/blog-detail/blog-detail.component')
          .then(m => m.BlogDetailComponent),
        data: { breadcrumb: 'Dieser Artikel'}
      }
    ]
  },
  {
    path: 'impressum',
    loadComponent: () => import('./sites/impressum/impressum.component')
      .then(m => m.ImpressumComponent)
  },
  {
    path: 'datenschutz',
    loadComponent: () => import('./sites/datenschutz/datenschutz.component')
      .then(m => m.DatenschutzComponent)
  },
  {
    path: 'password-reset',
    loadComponent: () => import('./sites/app/password-reset/password-reset.component')
      .then(m => m.PasswordResetComponent)
  },
  {
    path: 'verify',
    loadComponent: () => import('./sites/app/verify/verify.component')
      .then(m => m.VerifyComponent)
  },
  {
    path: 'rangliste',
    loadComponent: () => import('./sites/rangliste/rangliste.component')
      .then(m => m.RanglisteComponent),
  },
  {
    path: 'rangliste-2026',
    loadComponent: () => import('./sites/rangliste2026/rangliste2026.component')
      .then(m => m.Rangliste2026Component),
  },
  {
    path: 'dart-spielen-kassel',
    loadComponent: () => import('./sites/dartSpielenKassel/dart-spielen-kassel.component')
      .then(m => m.DartSpielenKasselComponent),
  },
  {
    path: 'faq',
    loadComponent: () => import('./sites/faq/faq.component')
      .then(m => m.FaqComponent),
    title: 'Häufige Fragen – Dart Rock Café Lohfelden',
    data: { breadcrumb: 'FAQ' }
  },
  {
    path: '**',
    loadComponent: () => import('./sites/not-found/not-found.component')
      .then(m => m.NotFoundComponent)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    anchorScrolling: "enabled",
    enableTracing: false,
    scrollPositionRestoration: "enabled",
    onSameUrlNavigation: "reload"
})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
